<template>
  <div class="dashboard__ttlspending" style="max-height: 110px;">
    <div class="p-5 d-flex justify-content-center align-items-center"
      v-if="isLoading">
      <half-circle-spinner
        :animation-duration="1500"
        :size="25"
        color="#1D3354"
        class="mx-auto"
      />
    </div>
    <div v-else class="d-flex">
      <div class="dashboard__ttlspending--content" style="width: 100%;">
        <div class="d-flex">
          <div class="mr-2">
            <img src="@/assets/image/icon/credit-green.svg" width="58px" height="58px" style="line-height:1;" alt="">
          </div>
          <div>
            <div class="fontstyle__title--sectionblue" style="color:#4FA462;">CREDIT BALANCE</div>
            <div class="d-flex justify-content-between  m-0 content__body--ttlspending">
              <div class="pr-0 mr-2 ttlspending__number d-flex justify-content-between">
                <p>{{creditData.creditBalance || '-' }}</p>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <span style="font-size: 12px; color:#7A7C7E; margin-bottom:5px; line-height: 1" class="mr-5">Credit Limit:</span>
              <span style="font-size: 12px; color:#7A7C7E; margin-bottom:5px; line-height: 1">Rp.{{creditData.creditLimit || '-'}}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-right: 2rem;margin-top: 1rem">
        <div id="tooltip-credit" style="width: 1rem;height: 1rem;border-radius: 100%;" :style="bgtNotif"></div>
        <b-tooltip v-if="bgtNotif !== 'background-color: #4FA462;'" id="andalin-credit" show target="tooltip-credit" placement="top">
          Your remaining Credit Balance is below {{ buttonNotice }}, please contact Salesperson
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'
export default {
  name: 'Credit',
  props: {
    datas: Object,
    isLoading: Boolean
  },
  data () {
    return {
      creditData: '',
      bgtNotif: '',
      buttonNotice: ''
    }
  },
  components: {
    HalfCircleSpinner
  },
  watch: {
    datas (data) {
      if (data.credits) {
        this.creditData = {
          creditBalance: data.credits.creditBalance.toLocaleString(),
          creditLimit: data.credits.creditLimit.toLocaleString()
        }
        if (data.credits.creditBalance >= (data.credits.creditLimit * 0.5)) {
          this.bgtNotif = 'background-color: #4FA462;' // Green
        } else if ((data.credits.creditBalance < (data.credits.creditLimit * 0.5) && (data.credits.creditBalance >= (data.credits.creditLimit * 0.2)))) {
          this.buttonNotice = '50%'
          this.bgtNotif = 'background-color: #FD9E00;' // Yellow
        } else if (data.credits.creditBalance < (data.credits.creditLimit * 0.2)) {
          this.buttonNotice = '20%'
          this.bgtNotif = 'background-color: #C4232A;' // Red
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Credit.vue